import React, { useContext, useEffect, useState } from 'react';
import ReactApexChart from 'react-apexcharts';
import { useTranslation } from 'react-i18next';
import { useMountedRef } from '../../hooks/useMountedRef';
import { UserContext } from '../../providers/UserProvider';
import { getGraphData, getOrders } from '../../services/cloudFirestore';

export function CollectionGraph(): React.ReactElement {
    const { t } = useTranslation();
    const mounted = useMountedRef();
    const user = useContext(UserContext);
    const [graphData, setGraphData] = useState<number[]>([0, 0, 0, 0, 0, 0, 0]);

    useEffect(() => {
        if (user && user.idProducteur && mounted.current) {
            getOrders(user.idProducteur).then((data) => {
                if (data && mounted.current && user.idProducteur) {
                    getGraphData(t, data, user.idProducteur).then((content) => {
                        if (content.length > 0) {
                            setGraphData(content);
                        }
                    });
                }
            });
        }
    }, []);

    const CHART_DATA = [
        {
            name: t('breakdownOfCollectionsPerSecond'),
            type: 'bar',
            data: graphData
        }
    ];

    const chartOptions: ApexCharts.ApexOptions = {
        colors: ['#134C03', '#134C03', '#134C03', '#134C03'],
        chart: {
            locales: [
                {
                    name: 'fr',
                    options: {
                        months: [
                            t('monday'),
                            t('tuesday'),
                            t('wednesday'),
                            t('thursday'),
                            t('friday'),
                            t('saturday'),
                            t('sunday')
                        ]
                    }
                }
            ],
            defaultLocale: 'fr',
            toolbar: { show: false },
            zoom: { enabled: false },
            animations: { enabled: false },
            stacked: true
        },
        dataLabels: { enabled: false },
        labels: [
            t('monday'),
            t('tuesday'),
            t('wednesday'),
            t('thursday'),
            t('friday'),
            t('saturday'),
            t('sunday')
        ],
        markers: { size: 5 },
        legend: { show: true, itemMargin: { vertical: 25 } },
        xaxis: { type: 'category' },
        yaxis: {
            tickAmount: 1,
            decimalsInFloat: 0,
            floating: false,
            labels: {
                formatter(val) {
                    return `${val.toFixed(0)}`;
                }
            }
        },
        tooltip: {
            shared: true,
            intersect: false,
            y: {
                formatter: (y: number) => {
                    if (typeof y !== 'undefined') {
                        return `${Math.round(y).toFixed(0)}`;
                    }
                    return y;
                }
            }
        }
    };

    return <ReactApexChart series={CHART_DATA} options={chartOptions} width="880px" height={375} />;
}
